module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.projetoPesquisa.titulo ? this.projetoPesquisa.titulo : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Sigla",
      "value": this.projetoPesquisa.sigla ? this.projetoPesquisa.sigla : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Área do Conhecimento",
      "value": this.projetoPesquisa.areaConhecimento ? this.projetoPesquisa.areaConhecimento.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome da Área",
      "value": this.projetoPesquisa.nomeArea ? this.projetoPesquisa.nomeArea.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome da Subárea",
      "value": this.projetoPesquisa.nomeSubarea ? this.projetoPesquisa.nomeSubarea.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação",
      "value": this.projetoPesquisa.linhaPesquisaPPG ? this.projetoPesquisa.linhaPesquisaPPG.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de início",
      "value": this.projetoPesquisa.dataInicio ? _vm.dates.format(this.projetoPesquisa.dataInicio) : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Prazo em meses",
      "value": this.projetoPesquisa.prazoMeses ? this.projetoPesquisa.prazoMeses : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Situação",
      "value": this.projetoPesquisa.situacao ? this.projetoPesquisa.situacao.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavras-chaves",
      "value": this.projetoPesquisa.palavrasChaves ? this.projetoPesquisa.palavrasChaves : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Resumo",
      "value": this.projetoPesquisa.resumo ? this.projetoPesquisa.resumo : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoAvancar()) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00de82a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/informacoes-basicas.vue
// module id = 810
// module chunks = 0